module.exports = __webpack_public_path__ + "img/qatar.19c06d8.webp";